export default function TS_Simple_Types() {
  return (
    <div>
      <h1>TS Simple Types</h1>
      <p>This is the TS Simple Types page.</p>
    </div>
  );
}